import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { api } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "@/lib/toast";
import { Lock, Mail, Loader2 } from "lucide-react";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in as admin
  if (user?.role === "admin") {
    navigate("/admin");
    return null;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Ingresa email y contraseña");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post("/auth/admin-login", { email, password });
      login(response.data.access_token, response.data.user);
      toast.success("¡Bienvenido Administrador!");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container aorra-admin-login">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 -left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 -right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="login-card aorra-admin-login-card relative z-10 animate-fade-in">
        {/* Logo */}
        <div className="flex flex-col items-center justify-center mb-8">
          <img 
            src="/logo-claro.png" 
            alt="Aorra" 
            className="h-12 mb-2"
          />
          <span className="aorra-admin-login-kicker">PANEL ADMINISTRATIVO</span>
        </div>

        <div className="text-center mb-8">
          <h1 className="aorra-admin-login-title text-2xl font-bold text-slate-900 dark:text-white font-['Outfit'] mb-2">
            Acceso Administrador
          </h1>
          <p className="text-slate-600 dark:text-slate-400">
            Ingresa tus credenciales de administrador
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2">
                <Mail className="w-5 h-5 text-slate-400" />
              </div>
              <Input
                id="email"
                type="email"
                placeholder="admin@finchat.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-11 h-12"
                data-testid="admin-email-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2">
                <Lock className="w-5 h-5 text-slate-400" />
              </div>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-11 h-12"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <Button 
            type="submit" 
            className="w-full h-12 btn-primary"
            disabled={loading}
            data-testid="admin-login-btn"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                Iniciar Sesión
                <Lock className="w-5 h-5 ml-2" />
              </>
            )}
          </Button>
        </form>

        <div className="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700 text-center">
          <button 
            onClick={() => navigate("/login")}
            className="aorra-admin-login-back text-sm text-cyan-600 hover:underline"
          >
            ← Volver al login de usuarios
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
